import { Card, CardContent, CardHeader, Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { EmptyIndicator, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'

type StatType = 'discharge' | 'load' | 'restow' | 'moves' | 'teu' | 'hatchCover' | 'oog'

interface VesselVisitOrderStatsProps {
  type: StatType
  title: string
  isCompleted: boolean
  stats?: { total?: number; completed?: number; planned?: number }
}

export const VesselVisitOrderStats = observer(
  ({
    title,
    type,
    isCompleted,
    stats = { total: 0, completed: 0, planned: 0 },
  }: VesselVisitOrderStatsProps) => {
    const { t } = useTranslate()
    const theme = useMinimalsTheme()
    const getSubTitle = (type: StatType) => {
      switch (type) {
        case 'discharge':
          return t('discharged', 'Discharged')
        case 'load':
          return t('loaded', 'Loaded')
        case 'restow':
          return t('restowed', 'Restowed')
        case 'moves':
          return t('moves', 'Moves')
        case 'teu':
          return t('teus', 'TEUs')
        case 'hatchCover':
          return t('hatchCover', 'Hatch Cover')
        case 'oog':
          return t('oog', 'OOG')
      }
    }

    return (
      <Card>
        <CardHeader title={<Typography variant='captionBold'>{title}</Typography>} />
        <CardContent>
          {isCompleted ? (
            <Stack direction='row' gap={theme.customSpacing.m}>
              <Typography variant='h4'>{stats?.completed ?? EmptyIndicator}</Typography>
            </Stack>
          ) : (
            <Stack direction='row' gap={theme.customSpacing.xll}>
              <Stack>
                <Typography variant='subtitle2' color={theme.palette.grey[600]}>
                  {t('total', 'Total')}
                </Typography>
                <Typography variant='h4'>{stats?.total}</Typography>
              </Stack>
              <Stack>
                <Typography variant='subtitle2' color={theme.palette.grey[600]}>
                  {getSubTitle(type)}
                </Typography>
                <Typography variant='h4'>{stats?.completed}</Typography>
              </Stack>
              <Stack>
                <Typography variant='subtitle2' color={theme.palette.grey[600]}>
                  {t('planned', 'Planned')}
                </Typography>
                <Typography variant='h4'>{stats?.planned}</Typography>
              </Stack>
            </Stack>
          )}
        </CardContent>
      </Card>
    )
  },
)
